import React, { useCallback, useState } from 'react';
import { Icon, Tooltip, Box } from '@cubeyou-team/hx-react-components';

import { getProductLink } from 'src/utils';
import { useOpenCreateSupportTicketModal } from 'src/hooks/useOpenCreateSupportTicketModal';

import { StyledSupportButton } from './Support.styles';
import translations from '../../lang';

const Support = () => {
  const [collapsed, setCollapsed] = useState(false);
  const openCreateSupportTicket = useOpenCreateSupportTicketModal();

  const handleDocumentation = useCallback(() => {
    const url = `https://${getProductLink('documentation')}`;
    window.open(url, '_blank', 'noopener,noreferrer');
  }, []);

  const SECTIONS = [
    {
      index: 1,
      icon: 'icon-ticket',
      tooltip: translations['en-US'].MODALS.HELP.CONTENT.DOCUMENTATION.TITLE,
      onClick: handleDocumentation,
      iconSize: 'medium',
    },
    {
      index: 0,
      icon: 'edit',
      tooltip:
        translations['en-US'].MODALS.create_support_ticket
          .createNewTicketTooltip,
      onClick: openCreateSupportTicket,
      iconSize: 'small',
    },
  ];

  const renderChildButton = (
    index,
    onClick,
    icon,
    tooltipContent,
    iconSize = 'medium'
  ) => (
    <Tooltip key={index} content={tooltipContent} position="left">
      <StyledSupportButton
        isChild
        index={index}
        collapsed={collapsed}
        onClick={onClick}
      >
        <Icon variant="light" icon={icon} size={iconSize} />
      </StyledSupportButton>
    </Tooltip>
  );

  return (
    <>
      <Box>
        {SECTIONS.map(({ index, onClick, icon, tooltip, iconSize }) =>
          renderChildButton(index, onClick, icon, tooltip, iconSize)
        )}
      </Box>
      <StyledSupportButton
        collapsed={collapsed}
        onClick={() => {
          setCollapsed(!collapsed);
        }}
      >
        {collapsed ? (
          <Icon variant="light" icon="remove" size="small" />
        ) : (
          translations['en-US'].MODALS.HELP.MODAL_TITLE
        )}
      </StyledSupportButton>
    </>
  );
};

export default Support;
